import { render, staticRenderFns } from "./OrganizationPositionsTab.vue?vue&type=template&id=266fde20"
import script from "./OrganizationPositionsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationPositionsTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationPositionsTab.vue?vue&type=style&index=0&id=266fde20&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports